import { Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../../services/spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { AuthService } from '../../services/auth.service';

export class BaseClass {
  public authService: AuthService;
  public formBuilder: FormBuilder;
  public router: Router;
  public spinnerService: SpinnerService;
  public toasterService: ToasterService;
  public activatedRoute: ActivatedRoute;
  public translateService: TranslateService;

  constructor(injector: Injector) {
    this.formBuilder = injector.get(FormBuilder);
    this.router = injector.get(Router);
    this.authService = injector.get(AuthService);
    this.activatedRoute = injector.get(ActivatedRoute);
    this.spinnerService = injector.get(SpinnerService);
    this.toasterService = injector.get(ToasterService);
    this.translateService = injector.get(TranslateService);
  }
}
